import { CronExpressionParser } from 'cron-parser';

export const getNextRuns = (
  cronExp: string,
  count = 5,
  opts?: { startDate?: Date | string | number; tz?: string }
): Date[] => {
  try {
    if (!cronExp || typeof cronExp !== 'string') return [];

    // split and trim
    const parts = cronExp.trim().split(/\s+/);

    // If Quartz 7-field, drop the YEAR (last field)
    if (parts.length === 7) {
      parts.pop(); // remove year
    }

    // Now parts length should be 5 or 6. cron-parser accepts 6 (sec included) or 5 (sec optional).
    // Ensure seconds exist: if 5 fields, prepend '0' (seconds = 0)
    if (parts.length === 5) {
      parts.unshift('0');
    }

    // Replace Quartz-only '?' with '*' for day-of-month (index 3) and day-of-week (index 5)
    // indexes (after ensuring 6 fields): 0=sec,1=min,2=hour,3=dom,4=month,5=dow
    if (parts[3] === '?') parts[3] = '*';
    if (parts[5] === '?') parts[5] = '*';

    const normalized = parts.join(' ');

    const parseOpts: Record<string, unknown> = {};
    if (opts?.startDate) parseOpts.currentDate = opts.startDate;
    if (opts?.tz) parseOpts.tz = opts.tz;

    const interval = CronExpressionParser.parse(normalized, parseOpts);

    const runs: Date[] = [];
    for (let i = 0; i < count; i++) {
      const next = interval.next();
      // Always use .toDate() to get a valid Date object from CronDate
      runs.push(next.toDate());
    }

    return runs;
  } catch (err) {
    console.error('Error parsing cron:', err);
    return [];
  }
};

